import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router-dom';
import Login from "../pages/admin/Login";
import Payment from "../pages/client/Payment";
import RouterErrorElement from "./Error/RouterErrorElement";
import Dashboard from "../pages/admin/dashboards/Dashboard";
import Users from "../pages/admin/users/Users";
import Roles from "../pages/admin/roles/Roles";
import RoleForm from "../pages/admin/roles/RoleForm";
import Languages from "../pages/admin/languages/Languages";
import LanguageForm from "../pages/admin/languages/LanguageForm";
import Countries from "../pages/admin/countries/Countries";
import CountryForm from "../pages/admin/countries/CountryForm";
import Currencies from "../pages/admin/currencies/Currencies";
import CurrencyForm from "../pages/admin/currencies/CurrencyForm";
import PayoutLimits from "../pages/admin/PayoutLimits";
import Logs from "../pages/admin/Logs";
import UserForm from "../pages/admin/users/UserForm";
import Profile from "../pages/admin/Profile";
import Providers from "../pages/admin/providers/Providers";
import ProviderForm from "../pages/admin/providers/ProviderForm";
import InputBuilderForm from "../pages/admin/InputBuilderForm";
import PaymentMethods from "../pages/admin/payment_methods/PaymentMethods";
import PaymentMethodForm from "../pages/admin/payment_methods/PaymentMethodForm";
import BrokerPaymentMethods from "../pages/admin/users/BrokerPaymentMethods";
import ChangePassword from "../pages/admin/ChangePassword";
import Deposits from "../pages/admin/reporting/Deposits";
import Withdraws from "../pages/admin/reporting/Withdraws";
import CallbacksMonitoring from "../pages/admin/reporting/CallbacksMonitoring";
import VirtualTerminal from "../pages/admin/VirtualTerminal";
import WithdrawsForm from "../pages/admin/withdraws/WithdrawsForm";
import Confirmations from "../pages/admin/Confirmations";
import Translations from "../pages/admin/Translations";
import {memo} from 'react';
import Regions from "../pages/admin/regions/Regions";
import RegionForm from "../pages/admin/regions/RegionForm";
import ReportingSchema from "../pages/admin/roles/ReportingSchema";
import BrokerReport from "../pages/admin/reporting/BrokerReport";
import Sources from "../pages/admin/sources/Sources";
import SourceForm from "../pages/admin/sources/SourceForm";
import Subscriptions from "../pages/admin/subscriptions/Subscriptions";
const Router =  () => {
    return (
        <RouterProvider router={createBrowserRouter(
            createRoutesFromElements(
                <Route path="/app" errorElement={<RouterErrorElement/>}>
                    <Route path="admin">
                        <Route index element={<Login/>}/>
                        <Route path="dashboard" element={<Dashboard/>}/>
                        <Route path="profile" element={<Profile/>}/>
                        <Route path="profile/password" element={<ChangePassword/>}/>
                        <Route path="payout_limits" element={<PayoutLimits/>}/>
                        <Route path="logs" element={<Logs/>}/>
                        <Route path="translations" element={<Translations/>}/>
                        <Route path="virtual_terminal" element={<VirtualTerminal/>}/>
                        <Route path="confirmations" element={<Confirmations/>}/>
                        <Route path="withdraws/create" element={<WithdrawsForm/>}/>
                        <Route path="logs/:id" element={<Logs/>}/>

                        <Route path="deposits" element={<Deposits/>}/>
                        <Route path="withdrawals" element={<Withdraws/>}/>
                        <Route path="reporting/callbacks" element={<CallbacksMonitoring/>}/>
                        <Route path="reporting/broker" element={<BrokerReport/>}/>


                        <Route path="users">
                            <Route index element={<Users/>}/>
                            <Route path="create" element={<UserForm/>}/>
                            <Route path=":id" element={<UserForm/>}/>
                            <Route path=":id/profile" element={<Profile/>}/>
                            <Route path=":id/payment_methods" element={<BrokerPaymentMethods/>}/>
                            <Route path=":id/deposits" element={<Deposits/>}/>
                            <Route path=":id/withdrawals" element={<Withdraws/>}/>
                        </Route>
                        <Route path="roles">
                            <Route index element={<Roles/>}/>
                            <Route path="schema" element={<ReportingSchema/>}/>
                            <Route path="create" element={<RoleForm/>}/>
                            <Route path=":id" element={<RoleForm/>}/>
                        </Route>
                        <Route path="languages">
                            <Route index element={<Languages/>}/>
                            <Route path="create" element={<LanguageForm/>}/>
                            <Route path=":id" element={<LanguageForm/>}/>
                        </Route>
                        <Route path="countries">
                            <Route index element={<Countries/>}/>
                            <Route path="create" element={<CountryForm/>}/>
                            <Route path=":id" element={<CountryForm/>}/>
                        </Route>
                        <Route path="regions">
                            <Route index element={<Regions/>}/>
                            <Route path="create" element={<RegionForm/>}/>
                            <Route path=":id" element={<RegionForm/>}/>
                        </Route>
                        <Route path="currencies">
                            <Route index element={<Currencies/>}/>
                            <Route path="create" element={<CurrencyForm/>}/>
                            <Route path=":id" element={<CurrencyForm/>}/>
                        </Route>
                        <Route path="payment_methods">
                            <Route index element={<PaymentMethods/>}/>
                            <Route path="create" element={<PaymentMethodForm/>}/>
                            <Route path=":id" element={<PaymentMethodForm/>}/>
                        </Route>
                        <Route path="providers">
                            <Route index element={<Providers/>}/>
                            <Route path="create" element={<ProviderForm/>}/>
                            <Route path=":id" element={<ProviderForm/>}/>
                            <Route path=":id/builder/credentials" element={<InputBuilderForm/>}/>
                            <Route path=":id/builder/client" element={<InputBuilderForm/>}/>
                        </Route>
                        <Route path="sources">
                            <Route index element={<Sources/>}/>
                            <Route path="create" element={<SourceForm/>}/>
                            <Route path=":id" element={<SourceForm/>}/>
                        </Route>
                        <Route path="subscriptions" element={<Subscriptions/>}/>
                    </Route>

                    <Route path="payment/:transaction" element={<Payment/>}/>
                </Route>
            )
        )}/>
    );
}

export default memo(Router);
